import axios from "./axios";
import { buildResponseArrayGetInterceptor, buildSearchURL } from "@/utils";

const baseUrl = "/api/v3/devices";

const STREAM_HEALTH_COLORS = {
  Upcoming: "#93A8BA",
  Init: "#FFB900",
  Setup: "#FFB900",
  Standby: "#FFB900",
  Live: "#00BC7D",
  "Delayed start": "#EC003F",
  "Not ready": "#EC003F",
  Unavailable: "#EC003F",
};

export default {
  get streamHealthColors() {
    return STREAM_HEALTH_COLORS;
  },
  get filtersValues() {
    return ["status", "streamHealth"];
  },
  get filtersOptions() {
    return {
      status: [
        {
          id: "upcoming",
          title: "Upcoming",
        },
        {
          id: "live",
          title: "Live",
        },
        {
          id: "unavailable",
          title: "Unavailable",
        },
      ],
      streamHealth: [
        {
          id: "Upcoming",
          title: "Upcoming",
        },
        {
          id: "Init",
          title: "Init",
        },
        {
          id: "Setup",
          title: "Setup",
        },
        {
          id: "Live",
          title: "Live",
        },
        {
          id: "Standby",
          title: "Standby",
        },
        {
          id: "Delayed start",
          title: "Delayed start",
        },
        {
          id: "Not ready",
          title: "Not ready",
        },
        {
          id: "Unavailable",
          title: "Unavailable",
        },
      ],
    };
  },
  getDevices(params) {
    return axios
      .get(`${baseUrl}${buildSearchURL(params)}`)
      .then((response) => buildResponseArrayGetInterceptor(response, params));
  },
};
